import { toast } from 'react-toastify';
import { exposedApi } from '../../../services/apiController';

export const GetJWVendorDetails = async (kitchenId) => {
  try {
    const response = await exposedApi(`/exposed/inv/jw/jw-vendor-details/${kitchenId}`);
    return response.data;
  } catch (err) {
    toast.error(err.message);
    throw err;
  }
};
